<div class="custom-table overflow-x-auto">
	<table class="bg-transparent w-full relative">
		<thead class="bg-off-white">
			<tr>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'CLIENT.CLIENT_DETAILS.BOOKING_NUMBER' | translate }}
				</td>

				<td
					class="text-center text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'GENERAL_LABELS.DATE' | translate }}
				</td>
				<td
					class="text-start text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'CLIENT.CLIENT_DETAILS.PAYMENT_METHOD' | translate }}
				</td>
				<td
					class="text-center text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'CLIENT.CLIENT_DETAILS.ACTIONS_STATUS' | translate }}
				</td>
			</tr>
		</thead>
		<tbody *ngIf="tableDetails?.length" class="bg-light-grey">
			<tr
				*ngFor="
					let detail of tableDetails
						| paginate
							: {
									itemsPerPage: clientProfileTableDetails?.paging?.pageSize,
									currentPage: clientProfileTableDetails?.paging?.pageNumber,
									totalItems: totalCount
							  }
				"
				class="border-b-[1px] border-secondry-color-Gray bg-light-grey"
			>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-light-grey py-[14px] px-[30px] max-mobile:px-padding-mobile-14"
				>
					<span>
						<span class="block text-dark-grey whitespace-nowrap">
							#{{ detail?.serialNumber }}
						</span>
						<span class="text-medium-gray">{{ detail?.branchName }} </span>
					</span>
				</td>

				<td
					class="text-center text-font-16 leading-[22px] text-[#4E4B66] bg-light-grey py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0">
						{{ detail?.date | date : 'dd/MM/yyyy' }}
					</h1>
					<h1 class="text-font-14 text-medium-gray max-mobile:text-font-12 m-0">
						{{ handelUtcToLocal(detail?.startTime) }}
					</h1>
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-light-grey py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0">
						{{ detail?.totalAmount }} {{ detail?.offer?.subTotal ? '|' : '' }}
						<span *ngIf="detail?.offer?.subTotal" class="line-through">
							{{ detail?.offer?.subTotal }}
							<!-- {{
								translate?.currentLang == 'ar'
									? serviceData?.currency?.name?.ar
									: serviceData?.currency?.name?.en
							}} -->
						</span>
						<Span>{{
							translate.currentLang == 'en'
								? detail?.currency?.name?.en
								: detail?.currency?.name?.ar
						}}</Span>
					</h1>
					<h1 class="text-font-14 text-medium-gray max-mobile:text-font-12 m-0">
						{{
							this.translate.currentLang == 'en'
								? detail?.paymentMethod?.name?.en
								: detail?.paymentMethod?.name?.ar
						}}
					</h1>
				</td>

				<td
					class="text-end text-font-16 leading-[22px] text-[#4E4B66] bg-light-grey py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p class="inline-block mr-[6px]">
						<app-status
							[ExtraText]="
								detail?.cancelledBy == 0 ||
								detail?.completedBy == 0 ||
								detail?.didnotShowUpBy == 0
									? ('GENERAL_LABELS.BY_CARE' | translate)
									: detail?.cancelledBy == 1 ||
									  detail?.completedBy == 1 ||
									  detail?.didnotShowUpBy == 1
									? ('GENERAL_LABELS.BY_CLIENT' | translate)
									: detail?.cancelledBy == 2 ||
									  detail?.completedBy == 2 ||
									  detail?.didnotShowUpBy == 2
									? ('GENERAL_LABELS.BY_SP' | translate)
									: ''
							"
							[enumData]="appointmentStatus"
							[statusValue]="detail?.status"
						></app-status>
					</p>
					<span
						class="inline-block max-mobile:w-[20px] w-[16px] text-end ltr:mr-[12px] rtl:ml-[12px]"
					>
						<button (click)="navigation(detail.id)">
							<img
								[src]="'assets/images/view.svg'"
								alt=""
								class="inline-block"
							/>
						</button>
					</span>
					<span class="inline-block max-mobile:w-[20px] w-[16px]"> </span>
				</td>
			</tr>
		</tbody>
	</table>

	<app-no-data-found
		*ngIf="!tableDetails?.length"
		[imageName]="'note.svg'"
		[text]="noDataFoundMessage"
	></app-no-data-found>
</div>
